import clsx from 'clsx';
import { StudentTag, studentTagLabel } from '@airreading/common/data';

interface StudentTagBadgeProps {
  tag: StudentTag;
}

const StudentTagColorMap: Record<StudentTag, string> = {
  obc: 'bg-[#DBEAFE] hover:bg-[#DBEAFE]',
  eir: 'bg-[#EDE9FE] hover:bg-[#EDE9FE]',
};

export const StudentTagBadge = ({ tag }: StudentTagBadgeProps) => {
  return (
    <div
      className={clsx(
        'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium text-secondary-foreground',
        StudentTagColorMap[tag],
      )}
    >
      {studentTagLabel(tag)}
    </div>
  );
};

interface StudentTagBadgeListProps {
  tags: StudentTag[] | null | undefined;
}

export const StudentTagBadgeList = ({ tags }: StudentTagBadgeListProps) => {
  if (!tags || tags.length === 0) {
    return <span className="text-muted-foreground">-</span>;
  }

  return (
    <div className="flex flex-wrap gap-1">
      {tags.map((tag) => (
        <StudentTagBadge key={tag} tag={tag} />
      ))}
    </div>
  );
};
